<template>
  <div>
    <Card>
      <Header @QueryHandleClick="QueryHandleClick" @ResetHandleClick="ResetHandleClick"/>
      <div style="margin-left: 1rem;margin-bottom: 1rem;"><Button type="info" shape="circle" icon="md-add" @click="NewBuildHandleClick">新增</Button></div>
      <NonStandardTable :CommonCommodityLists="CommonCommodityLists" @EditHandleClick="EditHandleClick" @DeleteHandleClick="DeleteHandleClick"/>
      <Page :total="total" show-sizer show-elevator style="margin:1rem 0 8.3rem 0;text-align: center;" @on-change="PageChangeHandleClick" @on-page-size-change="PageSizeChangeHandleClick"/>
      <Spin size="large" fix v-if="SpinShow"></Spin>
    </Card>

     <!-- 抽屉1 -->
    <Drawer title="非标商品维护" v-model="isDrawer" width="80" :mask-closable="false">
        <Form  :model="FormData" ref="formCustom" :rules="ruleCustom">
          <Row :gutter="32">
            <Col span="12">
              <FormItem label="常用商品ID">
                <Input  v-model="FormData.Common_commodity_id" value="FormData.Common_commodity_id"  readonly/>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="用户Openid" prop="openid">
                <Input  v-model="FormData.openid" value="FormData.openid" readonly/>
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="32">
            <Col span="12">
              <FormItem label="客户名称">
                <Input search v-model="FormData.Customer_Name" value="FormData.Customer_Name" enter-button="选择" @on-search="Customer_NameSelectHandleClick" readonly/>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="物料ID">
                <Input  v-model="FormData.ProductID" value="FormData.ProductID" readonly/>
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="32">
            <Col span="12">
              <FormItem label="物料名称" prop="ProductName">
                <Input search v-model="FormData.Product_Name" value="FormData.Product_Name" enter-button="选择" @on-search="ProductSelectHandleClick" readonly/>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="物料大类">
                <Input v-model="FormData.Classification" value="FormData.Classification" readonly/>
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="32">
            <Col span="12">
              <FormItem label="单重" prop="SingleWeight">
                <Input type="number"  v-model="FormData.SingleWeight" value="FormData.SingleWeight" />
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="辅助数量" prop="AuxiliaryQuantity">
                <Input  v-model="FormData.AuxiliaryQuantity" value="FormData.AuxiliaryQuantity" />
              </FormItem>
            </Col>
          </Row>
          <FormItem label="属性汇总">
                <Input  v-model="FormData.Attribute_Summary" value="FormData.material_subclass" readonly/>
          </FormItem>
        </Form>
        <div class="demo-drawer-footer">
          <Button style="margin-right: 8px" @click="CancelHandleClick">取消</Button>
          <Button type="primary" @click="SubmitHandleClick('formCustom')">提交</Button>
        </div>
      </Drawer>

      <!-- 窗口2 -->
      <Drawer title="列表" :closable="false" width="75" v-model="isDrawer2">
        <NonStandardCustomer v-if="SelectiontValue === '客户'" @SelecttionHandleClick="SelecttionHandleClick"/>
        <NonStandardProduct v-if="SelectiontValue === '物料'" @SelectionPHandleClick="SelectionPHandleClick"/>
      </Drawer>
  </div>
</template>

<script>
import { GetNonStandardTableApi, ChangeNonStandardData } from '../../../api/Miscellaneous.js'
import Header from './component/NonStandardHeader.vue'
import NonStandardTable from './component/NonStandardTable.vue'
import NonStandardCustomer from './component/NonStandardCustomer.vue'
import NonStandardProduct from './component/NonStandardProduct.vue'
export default {
  name: 'NonStandard',
  components: {
    Header,
    NonStandardTable,
    NonStandardCustomer,
    NonStandardProduct
  },
  data () {
    const validatemateropenid = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输对应的客户'))
      }
      callback()
    }
    const validatematerProductName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输对应的物料信息'))
      }
      callback()
    }

    const validatematerSingleWeight = (rule, value, callback) => {
      if (value <= 0) {
        callback(new Error('请输入单重'))
      }
      callback()
    }
    const validatematerAuxiliaryQuantity = (rule, value, callback) => {
      if (value <= 0) {
        callback(new Error('请输入辅助数量'))
      }
      callback()
    }
    return {
      CommonCommodityLists: [],
      SalespersonID: '', // 销售员id
      formItem: {
        Customer: '',
        materiel_code: '',
        materiel_name: '',
        material_category: ''
      },
      total: 0,
      CurrentPage: 1,
      pageSize: 10,
      SpinShow: false,
      isDrawer: false,
      isDrawer2: false,
      FormData: {
        Common_commodity_id: '',
        ProductID: '',
        Product_Name: '',
        Attribute_Summary: '',
        Classification: '',
        ClassificationID: '',
        openid: '',
        Customer_Name: '',
        SingleWeight: '',
        AuxiliaryQuantity: ''
      },
      State: 0,
      ruleCustom: {
        openid: [{ validator: validatemateropenid, trigger: 'blur' }],
        ProductName: [{ validator: validatematerProductName, trigger: 'blur' }],
        SingleWeight: [{ validator: validatematerSingleWeight, trigger: 'blur' }],
        AuxiliaryQuantity: [{ validator: validatematerAuxiliaryQuantity, trigger: 'blur' }]
      },
      SelectiontValue: ''
    }
  },
  mounted: function () {
    if (this.$store.state.userInfo.roleName === '销售员') { this.SalespersonID = this.$store.state.userInfo.userID }
    this.GetNonStandardTableList()
  },
  methods: {
    // 获取明细数据
    GetNonStandardTableList () {
      this.SpinShow = true
      GetNonStandardTableApi({
        Customer: this.formItem.Customer,
        materiel_code: this.formItem.materiel_code,
        materiel_name: this.formItem.materiel_name,
        material_category: this.formItem.material_category,
        SalespersonID: this.SalespersonID,
        CurrentPage: this.CurrentPage,
        pageSize: this.pageSize
      }).then((res) => {
        if (res.IsSuccess) {
          this.total = res.Data.Table[0].total
          this.CommonCommodityLists = res.Data.Table1
          this.SpinShow = false
        } else {
          this.SpinShow = false
          this.$Message.error(res.Message)
        }
      })
    },
    // 切换页数
    PageChangeHandleClick (res) {
      if (this.CurrentPage !== res) {
        this.CurrentPage = res
        this.GetNonStandardTableList()
      }
    },
    // 每页数据量改变
    PageSizeChangeHandleClick (res) {
      if (this.pageSize !== res) {
        this.pageSize = res
        this.GetNonStandardTableList()
      }
    },
    // 点击查询按钮回调
    QueryHandleClick (item) {
      this.formItem = {
        Customer: item.Customer,
        materiel_code: item.materiel_code,
        materiel_name: item.materiel_name,
        material_category: item.material_category
      }
      this.CurrentPage = 1
      this.GetNonStandardTableList()
    },
    // 点击重置按钮回调
    ResetHandleClick () {
      this.formItem = {
        Customer: '',
        materiel_code: '',
        materiel_name: '',
        material_category: ''
      }
      this.CurrentPage = 1
      this.GetNonStandardTableList()
    },
    // 点击新增按钮触发事件
    NewBuildHandleClick () {
      this.State = 0
      this.FormData = {
        Common_commodity_id: '',
        ProductID: '',
        Product_Name: '',
        Attribute_Summary: '',
        Classification: '',
        ClassificationID: '',
        openid: '',
        Customer_Name: '',
        SingleWeight: '',
        AuxiliaryQuantity: ''
      }
      this.isDrawer = true
    },
    // 点击编辑事件回调
    EditHandleClick (index) {
      this.State = 1
      this.FormData = {
        Common_commodity_id: this.CommonCommodityLists[index].Common_commodity_id,
        ProductID: this.CommonCommodityLists[index].ProductID,
        Product_Name: this.CommonCommodityLists[index].Product_Name,
        Attribute_Summary: this.CommonCommodityLists[index].Attribute_Summary,
        Classification: this.CommonCommodityLists[index].Classification,
        ClassificationID: this.CommonCommodityLists[index].ClassificationID,
        openid: this.CommonCommodityLists[index].openid,
        Customer_Name: this.CommonCommodityLists[index].Customer_Name,
        SingleWeight: this.CommonCommodityLists[index].SingleWeight,
        AuxiliaryQuantity: this.CommonCommodityLists[index].AuxiliaryQuantity
      }
      this.isDrawer = true
    },
    // 点击删除按钮后回调
    DeleteHandleClick (index) {
      this.State = 2
      this.FormData.Common_commodity_id = this.CommonCommodityLists[index].Common_commodity_id
      this.OKHandleClick()
    },
    // 客户选择回调
    Customer_NameSelectHandleClick () {
      this.SelectiontValue = '客户'
      this.isDrawer2 = true
    },
    // 客户信息选择后回调
    SelecttionHandleClick (info) {
      this.FormData.Customer_Name = info.Customer_Name
      this.FormData.openid = info.openid
      this.isDrawer2 = false
    },
    // 物料信息选择后回调
    ProductSelectHandleClick () {
      this.SelectiontValue = '物料'
      this.isDrawer2 = true
    },
    // 物料信息选择后回调
    SelectionPHandleClick (info) {
      this.FormData.ProductID = info.ProductID
      this.FormData.Product_Name = info.Product_Name
      this.FormData.Classification = info.Classification
      this.FormData.ClassificationID = info.ClassificationID
      this.FormData.Attribute_Summary = info.Attribute_Summary
      this.isDrawer2 = false
    },
    // 抽屉点击取消后回调
    CancelHandleClick () {
      this.isDrawer = false
      this.FormData = {
        Common_commodity_id: '',
        ProductID: '',
        Product_Name: '',
        Attribute_Summary: '',
        Classification: '',
        ClassificationID: '',
        openid: '',
        Customer_Name: '',
        SingleWeight: '',
        AuxiliaryQuantity: ''
      }
    },
    // 点击提交后回调
    SubmitHandleClick (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.OKHandleClick()
        } else {
          this.$Message.error('Fail!')
        }
      })
    },
    // 更新非标常用商品信息
    OKHandleClick () {
      ChangeNonStandardData({
        Common_commodity_id: this.FormData.Common_commodity_id,
        openid: this.FormData.openid,
        ProductID: this.FormData.ProductID,
        SingleWeight: this.FormData.SingleWeight,
        AuxiliaryQuantity: this.FormData.AuxiliaryQuantity,
        operation: this.State
      }).then((res) => {
        if (res.IsSuccess) {
          this.isDrawer = false
          this.$Message['success']({
            background: true,
            content: '提交成功'
          })
          this.GetNonStandardTableList()
        } else {
          this.$Message.error(res.Message)
        }
      })
    }
  }
}
</script>
